import { Control } from "ol/control";

class SubirCapa extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const tipLabel = options.tipLabel ? options.tipLabel : "Subir capa";

    const button = document.createElement("button");
    button.title = tipLabel;
    button.innerText = "";
    const element = document.createElement("div");
    element.className = "subir-capa ol-unselectable ol-control";
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    this.impresionDialog = document.getElementById("subir-capa-dialog");
    let cancelDialog = document.getElementById("subir-capa-cancel");

    button.addEventListener("click", this.handleOpenDialog.bind(this), false);

    cancelDialog.addEventListener("click", () => {
      this.handleCloseDialog();
    });
  }

  handleCloseDialog() {
    this.impresionDialog.close();
  }

  handleOpenDialog() {
    this.impresionDialog.showModal();
  }
}

export default SubirCapa;
